import { z } from 'zod';

const IsoDate = z.iso.date();

/** `POST /voll-wallet/receipts/read` — o comprovante já guardado cuja data e valor o OCR lê. */
export const VollWalletReceiptReadingRequestSchema = z
  .object({
    /** The wallet whose OCR switch decides the reading; absent = the receipt comes before the
     *  wallet (#6561), and any of the person's wallets with OCR on lets it read. */
    walletId: z.string().min(1).optional(),
    receiptId: z.string().min(1),
    /** The colleague whose wallet the refund uses; absent = the traveler themself. */
    travelerId: z.string().min(1).max(64).optional(),
  })
  .strict();
export type VollWalletReceiptReadingRequest = z.infer<typeof VollWalletReceiptReadingRequestSchema>;

/** O que o OCR do comprovante leu: só o que veio válido; campo ausente = não leu. `illegible`:
 *  a imagem fica abaixo do limiar de qualidade do legado e uma carteira da pessoa bloqueia
 *  imagem ilegível (#6561) — nada mais é lido, e o comprovante precisa ser enviado de novo. */
export const VollWalletReceiptReadingSchema = z
  .object({
    date: IsoDate.optional(),
    amount: z.number().positive().optional(),
    illegible: z.literal(true).optional(),
  })
  .strict();
export type VollWalletReceiptReading = z.infer<typeof VollWalletReceiptReadingSchema>;

/** O câmbio do dia do recibo (reais por unidade da moeda); ausente = sem cotação. */
export const VollWalletExchangeRateSchema = z
  .object({ rate: z.number().positive().optional(), date: IsoDate.optional() })
  .strict();
export type VollWalletExchangeRate = z.infer<typeof VollWalletExchangeRateSchema>;
